import { render, staticRenderFns } from "./CollectionForm.vue?vue&type=template&id=00948232&scoped=true&"
import script from "./CollectionForm.vue?vue&type=script&lang=js&"
export * from "./CollectionForm.vue?vue&type=script&lang=js&"
import style0 from "./CollectionForm.vue?vue&type=style&index=0&id=00948232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00948232",
  null
  
)

export default component.exports